(function (window, document) {
  'use strict';

  if (window.__bbOpenAIAdsRuntimeStarted) return;
  window.__bbOpenAIAdsRuntimeStarted = true;

  var isTopFrame = false;
  try {
    isTopFrame = window.self === window.top;
  } catch (error) {
    isTopFrame = false;
  }
  if (!isTopFrame) return;

  var contextNode = document.getElementById('bb-openai-ads-context');
  if (!contextNode) return;

  var context;
  try {
    context = JSON.parse(contextNode.textContent || '{}');
  } catch (error) {
    return;
  }

  var consentGranted = false;
  var measuredOnce = Object.create(null);
  var designMode = Boolean(window.Shopify && window.Shopify.designMode);
  var currency = normalizeCurrency(context.currency);
  var cartState = normalizeCart(context.cart);
  var consentEndpoint = typeof context.consentEndpoint === 'string' ? context.consentEndpoint : '';
  var consentAttribute = typeof context.consentAttribute === 'string'
    ? context.consentAttribute
    : '__openai_ads_consent_receipt';
  var cartUpdateUrl = typeof context.cartUpdateUrl === 'string'
    ? context.cartUpdateUrl
    : '/cart/update.js';
  var receiptSessionKey = '_bb_oaiq_consent_receipt_v1';
  var receiptSyncGeneration = 0;
  var receiptRequest = null;
  var receiptReady = false;
  var denialSynchronized = false;
  var receiptSyncTimer = null;
  var desiredConsentState = false;

  function textValue(value) {
    return value === null || value === undefined ? '' : String(value);
  }

  function boundedValue(value, maxLength) {
    var normalized = textValue(value).trim();
    if (!normalized || normalized.length > maxLength || /[\u0000-\u001f\u007f]/.test(normalized)) return '';
    return normalized;
  }

  // Consent identity only: Shopify's Ajax Cart token can carry a terminal
  // ?key= secret that is not present in checkout/order webhooks. Keep the
  // full token untouched for Ajax Cart API calls and normalize only here.
  function normalizeCartTokenForConsent(value) {
    if (typeof value !== 'string' || !value || value.length > 4096 || /[\s\u0000-\u001f\u007f]/.test(value)) return '';
    var marker = '?key=';
    var markerIndex = value.indexOf(marker);
    if (markerIndex === -1) return value;
    if (markerIndex !== value.lastIndexOf(marker)) return '';
    var baseToken = value.slice(0, markerIndex);
    var keySuffix = value.slice(markerIndex + marker.length);
    if (!baseToken || !keySuffix || /[?&#]/.test(keySuffix) || /%(?![0-9a-f]{2})/i.test(keySuffix)) return '';
    return baseToken;
  }

  // Read provider cookies only after marketing consent; preserve opaque bytes.
  function opaqueReference(value) {
    if (typeof value !== 'string' || value.length > 1024 || !value.trim()) return '';
    for (var i = 0; i < value.length; i += 1) {
      var code = value.charCodeAt(i);
      if (code <= 31 || code === 127) return '';
    }
    return value;
  }

  function attributionFieldValue(field, value) {
    return field === 'oppref' || field === 'obref'
      ? opaqueReference(value) : boundedValue(value, attributionFields[field]);
  }

  function currentReference(name) {
    if (!consentGranted) return '';
    var query = opaqueReference(queryValue(name));
    if (query) return query;
    var stored = opaqueReference(currentAttribution && currentAttribution[name]);
    var cookie = opaqueReference(cookieValue('__' + name));
    return name === 'obref' ? cookie || stored : stored || cookie;
  }

  var lastReceiptReferences = '';
  var referenceWatchTimer = null;
  var referenceWatchAttempt = 0;

  function referenceSignature() {
    return JSON.stringify([currentReference('oppref'), currentReference('obref')]);
  }

  function watchPixelReferences() {
    if (!consentGranted || designMode) return;
    if (receiptReady && lastReceiptReferences !== referenceSignature()) receiptReady = false;
    syncConsentReceipt(true);
    if (referenceWatchTimer || referenceWatchAttempt >= 6) return;
    var delay = Math.pow(2, referenceWatchAttempt++) * 1000;
    referenceWatchTimer = window.setTimeout(function () {
      referenceWatchTimer = null;
      watchPixelReferences();
    }, delay);
  }

  function stopReferenceWatch() {
    if (referenceWatchTimer) window.clearTimeout(referenceWatchTimer);
    referenceWatchTimer = null;
    referenceWatchAttempt = 0;
    lastReceiptReferences = '';
  }

  var attributionStorageKey = '__openai_ads_attribution_v1';
  var attributionTtlMs = 30 * 24 * 60 * 60 * 1000;
  var attributionFields = {
    oppref: 1024,
    obref: 1024,
    utm_source: 128,
    utm_medium: 128,
    utm_campaign: 256,
    utm_content: 256,
    openai_ad_group_id: 256,
    openai_ad_account_id: 256
  };
  var cartAttributionFields = {
    utm_source: '__openai_ads_utm_source',
    utm_medium: '__openai_ads_utm_medium',
    utm_campaign: '__openai_ads_utm_campaign',
    utm_content: '__openai_ads_utm_content',
    openai_ad_group_id: '__openai_ads_ad_group_id',
    openai_ad_account_id: '__openai_ads_ad_account_id'
  };
  var consentObservationMethod = 'stored_explicit_grant';

  function parseStoredAttribution(nowMs) {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(attributionStorageKey) || 'null');
      if (!parsed || typeof parsed !== 'object' || !Number.isSafeInteger(parsed.capturedAt) ||
          parsed.capturedAt > nowMs + 300000 || nowMs - parsed.capturedAt > attributionTtlMs) return null;
      var values = { capturedAt: parsed.capturedAt };
      Object.keys(attributionFields).forEach(function (field) {
        var value = attributionFieldValue(field, parsed[field]);
        if (value) values[field] = value;
      });
      return values;
    } catch (error) {
      return null;
    }
  }

  function captureAttribution() {
    var nowMs = Date.now();
    var current = parseStoredAttribution(nowMs);
    try {
      var params = new window.URL(window.location.href).searchParams;
      var candidate = { capturedAt: nowMs };
      Object.keys(attributionFields).forEach(function (field) {
        var value = attributionFieldValue(field, params.get(field));
        if (value) candidate[field] = value;
      });
      var isOpenAIClick = Boolean(candidate.oppref || candidate.obref) ||
        String(candidate.utm_source || '').toLowerCase() === 'openai';
      if (!isOpenAIClick) return current;
      try { window.localStorage.setItem(attributionStorageKey, JSON.stringify(candidate)); } catch (storageError) {}
      return candidate;
    } catch (error) {
      return current;
    }
  }

  var currentAttribution = captureAttribution();

  function sessionReceipt() {
    try {
      return boundedValue(window.sessionStorage.getItem(receiptSessionKey), 4096);
    } catch (error) {
      return '';
    }
  }

  function storeSessionReceipt(receipt) {
    try {
      if (receipt) window.sessionStorage.setItem(receiptSessionKey, receipt);
      else window.sessionStorage.removeItem(receiptSessionKey);
    } catch (error) {}
  }

  function cookieValue(name) {
    var prefix = name + '=';
    var pairs = textValue(document.cookie).split(';');
    for (var index = 0; index < pairs.length; index += 1) {
      var pair = pairs[index].replace(/^\s+/, '');
      if (pair.indexOf(prefix) !== 0) continue;
      try {
        return decodeURIComponent(pair.slice(prefix.length));
      } catch (error) {
        return ''; // A malformed encoded cookie is not a provider reference.
      }
    }
    return '';
  }

  function queryValue(name) {
    try {
      return new URL(window.location.href).searchParams.get(name) || '';
    } catch (error) {
      return '';
    }
  }

  function attributionValue(queryName, cookieName) {
    return boundedValue(queryValue(queryName) || cookieValue(cookieName), 1024);
  }

  function cartReceipt(cart) {
    var attributes = cart && cart.attributes;
    return boundedValue(attributes && attributes[consentAttribute], 4096);
  }

  function readCartForConsent() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    var cartUrl = context.cartUrl || (typeof root === 'string' ? root : '/') + 'cart.js';
    return window.fetch(cartUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('Cart read failed');
      return response.json();
    });
  }

  function cartHasAttribution(cart) {
    var attributes = cart && cart.attributes;
    if (!attributes) return false;
    return Object.keys(cartAttributionFields).some(function (field) {
      return !!attributes[cartAttributionFields[field]];
    });
  }

  function updateCartReceipt(receipt) {
    var attributes = {};
    attributes[consentAttribute] = receipt || '';
    Object.keys(cartAttributionFields).forEach(function (field) {
      attributes[cartAttributionFields[field]] = receipt && currentAttribution
        ? boundedValue(currentAttribution[field], attributionFields[field])
        : '';
    });
    return window.fetch(cartUpdateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('Cart attribute update failed');
      return response;
    });
  }

  function sha256Hex(rawBody) {
    if (!window.crypto || !window.crypto.subtle || typeof window.crypto.subtle.digest !== 'function') {
      return Promise.reject(new Error('Web Crypto is required'));
    }
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(rawBody)).then(function (digest) {
      return Array.prototype.map.call(new Uint8Array(digest), function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  function consentId() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return privacy && typeof privacy.consentId === 'function'
        ? boundedValue(privacy.consentId(), 512)
        : '';
    } catch (error) {
      return '';
    }
  }

  function postConsent(body) {
    var payload = Object.assign({}, body, {
      consentId: consentId(),
      observedAt: new Date().toISOString(),
      noticeVersion: 'bebelux-cookie-banner-v1',
      method: consentObservationMethod
    });
    var rawBody = JSON.stringify(payload);
    return sha256Hex(rawBody).then(function (digest) {
      var separator = consentEndpoint.indexOf('?') >= 0 ? '&' : '?';
      return window.fetch(consentEndpoint + separator + 'body_sha256=' + encodeURIComponent(digest), {
        method: 'POST',
        credentials: 'omit',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: rawBody
      });
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('Consent receipt request failed');
      return response.json();
    });
  }

  function grantConsentReceipt() {
    if (receiptReady || receiptRequest || !consentGranted) return;
    var generation = receiptSyncGeneration + 1;
    receiptSyncGeneration = generation;
    denialSynchronized = false;
    receiptRequest = readCartForConsent().then(function (cart) {
      var cartToken = normalizeCartTokenForConsent(cart && cart.token);
      if (!cartToken) throw new Error('Cart token unavailable');
      var presentedReceipt = cartReceipt(cart) || sessionReceipt();
      var body = { consent: 'granted', cartToken: cartToken };
      if (presentedReceipt) body.receipt = presentedReceipt;
      var oppref = currentReference('oppref');
      var obref = currentReference('obref');
      lastReceiptReferences = JSON.stringify([oppref, obref]);
      if (oppref) body.oppref = oppref;
      if (obref) body.obref = obref;
      return postConsent(body).then(function (result) { if (result && typeof result === 'object') result.__cartToken = cartToken; return result; });
    }).then(function (result) {
      var receipt = boundedValue(result && result.receipt, 4096);
      if (!receipt) throw new Error('Consent receipt missing');
      if (!consentGranted || generation !== receiptSyncGeneration) {
        return postConsent({ consent: 'revoked', receipt: receipt, cartToken: result.__cartToken }).catch(function () {});
      }
      return updateCartReceipt(receipt).then(function () {
        if (!consentGranted || generation !== receiptSyncGeneration) return;
        storeSessionReceipt(receipt);
        receiptReady = true;
      });
    }).catch(function () {
      receiptReady = false;
    }).finally(function () {
      receiptRequest = null;
      if (!desiredConsentState) syncConsentReceipt(false);
    });
  }

  function revokeConsentReceipt() {
    if (denialSynchronized || receiptRequest || !consentEndpoint || typeof window.fetch !== 'function') return;
    receiptSyncGeneration += 1;
    receiptReady = false;
    var knownReceipt = sessionReceipt();
    receiptRequest = readCartForConsent().catch(function () { return null; }).then(function (cart) {
      var receipt = cartReceipt(cart) || knownReceipt;
      var cartToken = normalizeCartTokenForConsent(cart && cart.token);
      var revoked = !receipt;
      var revocation = receipt
        ? postConsent({ consent: 'revoked', receipt: receipt, cartToken: cartToken })
          .then(function () { revoked = true; })
          .catch(function () {})
        : Promise.resolve();
      // Only clear when there is something to clear: a blind POST to /cart/update.js on every
      // page view without consent would create a cart for every visitor (Lighthouse 12.10.2026).
      var needsClear = cart ? (!!receipt || cartHasAttribution(cart)) : !!knownReceipt;
      return revocation.then(function () {
        return needsClear ? updateCartReceipt('').catch(function () {}) : null;
      }).then(function () {
        if (revoked) {
          storeSessionReceipt('');
          denialSynchronized = true;
        }
      });
    }).finally(function () {
      receiptRequest = null;
      if (desiredConsentState) syncConsentReceipt(true);
    });
  }

  function syncConsentReceipt(allowed) {
    desiredConsentState = allowed === true;
    if (!consentEndpoint || typeof window.fetch !== 'function' || designMode) return;
    if (!allowed) {
      stopReferenceWatch();
      if (receiptSyncTimer) window.clearTimeout(receiptSyncTimer);
      receiptSyncTimer = null;
      revokeConsentReceipt();
      return;
    }
    if (receiptReady || receiptRequest || receiptSyncTimer) return;
    receiptSyncTimer = window.setTimeout(function () {
      receiptSyncTimer = null;
      grantConsentReceipt();
    }, 100);
  }

  function normalizeCurrency(value) {
    var normalized = typeof value === 'string' ? value.toUpperCase() : '';
    return /^[A-Z]{3}$/.test(normalized) ? normalized : '';
  }

  function integer(value) {
    var parsed = Number(value);
    return isFinite(parsed) && Math.floor(parsed) === parsed ? parsed : null;
  }

  function positiveInteger(value, fallback) {
    var parsed = integer(value);
    return parsed !== null && parsed > 0 ? parsed : fallback;
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'bb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 14);
  }

  function command() {
    if (typeof window.oaiq === 'function') {
      window.oaiq.apply(window, arguments);
    }
  }

  function normalizeItem(raw, quantityOverride) {
    if (!raw || typeof raw !== 'object') return null;
    var rawId = raw.variant_id !== undefined ? raw.variant_id : raw.id;
    if (rawId === undefined || rawId === null || rawId === '') return null;

    var quantity = positiveInteger(quantityOverride, positiveInteger(raw.quantity, 1));
    var rawAmount = raw.amount;
    if (rawAmount === undefined) rawAmount = raw.final_price;
    if (rawAmount === undefined) rawAmount = raw.price;

    var name = raw.product_title || raw.name || raw.title || String(rawId);
    return {
      id: String(rawId),
      name: String(name),
      quantity: quantity,
      amount: integer(rawAmount)
    };
  }

  function normalizeCart(rawCart) {
    var normalized = { total: null, items: [] };
    if (!rawCart || typeof rawCart !== 'object') return normalized;
    var rawItems = Array.isArray(rawCart.items) ? rawCart.items : [];
    normalized.items = rawItems.map(function (item) {
      return normalizeItem(item);
    }).filter(Boolean);
    var rawTotal = rawCart.total;
    if (rawTotal === undefined) rawTotal = rawCart.total_price;
    normalized.total = integer(rawTotal);
    return normalized;
  }

  function contentFromItem(item) {
    var content = {
      id: item.id,
      name: item.name,
      content_type: 'product',
      quantity: item.quantity
    };
    if (item.amount !== null && item.amount >= 0 && currency) {
      content.amount = item.amount;
      content.currency = currency;
    }
    return content;
  }

  function contentsProperties(items, total) {
    var properties = { type: 'contents' };
    if (items.length) {
      properties.contents = items.map(contentFromItem);
    }
    if (total !== null && total >= 0 && currency) {
      properties.amount = total;
      properties.currency = currency;
    }
    return properties;
  }

  function measure(eventName, properties) {
    if (!consentGranted || designMode) return false;
    command('measure', eventName, properties, { event_id: eventId() });
    return true;
  }

  function measureOnce(key, eventName, properties) {
    if (measuredOnce[key]) return false;
    if (!measure(eventName, properties)) return false;
    measuredOnce[key] = true;
    return true;
  }

  function productVariant(variantId) {
    if (!context.product || !Array.isArray(context.product.variants)) return null;
    var sought = String(variantId || context.product.viewedVariantId || '');
    for (var index = 0; index < context.product.variants.length; index += 1) {
      if (String(context.product.variants[index].id) === sought) {
        return context.product.variants[index];
      }
    }
    return null;
  }

  function productItem(variantId, quantity) {
    var variant = productVariant(variantId);
    if (!variant || !context.product) return null;
    var name = String(context.product.title || variant.id);
    if (variant.title && variant.title !== 'Default Title') {
      name += ' - ' + variant.title;
    }
    return normalizeItem({
      id: variant.id,
      name: name,
      quantity: quantity,
      amount: variant.amount
    });
  }

  function directCheckoutItems(rawItems) {
    if (typeof rawItems !== 'string') return [];
    var counts = Object.create(null);
    rawItems.split(',').forEach(function (entry) {
      var normalized = entry.trim();
      var separator = normalized.lastIndexOf(':');
      if (separator <= 0) return;
      var id = normalized.slice(0, separator).trim();
      var quantity = integer(normalized.slice(separator + 1));
      if (!id || quantity === null || quantity <= 0) return;
      counts[id] = (counts[id] || 0) + quantity;
    });
    return Object.keys(counts).map(function (id) {
      return productItem(id, counts[id]) || normalizeItem({
        id: id,
        name: id,
        quantity: counts[id]
      });
    }).filter(Boolean);
  }

  function emitInitialPageEvents() {
    measureOnce('page_viewed', 'page_viewed', { type: 'contents' });

    var item = productItem(context.product && context.product.viewedVariantId, 1);
    if (item) {
      measureOnce('contents_viewed', 'contents_viewed', contentsProperties([item], item.amount));
    }
  }

  // The caller has finished Ajax Cart mutations. Re-read that exact cart
  // and finish its receipt/attribution write before leaving the storefront.
  window.bbOpenAIAdsPrepareCheckout = function () {
    syncMarketingConsent();
    if (!consentGranted || designMode) return Promise.resolve(false);
    if (receiptSyncTimer) window.clearTimeout(receiptSyncTimer);
    receiptSyncTimer = null;
    return Promise.resolve(receiptRequest).then(function () {
      if (!consentGranted) return false;
      receiptReady = false;
      grantConsentReceipt();
      return receiptRequest;
    }).then(function () { return receiptReady; });
  };

  document.addEventListener('bb:direct-checkout', function (event) {
    var detail = event && event.detail;
    var items = directCheckoutItems(detail && detail.items);
    if (!items.length) return;
    var properties = contentsProperties(items, null);
    if (!detail.cartAlreadyAdded) measure('items_added', properties);
    measureOnce('checkout_started', 'checkout_started', properties);
  });

  function setMarketingConsent(value) {
    var nextValue = value === true;
    if (nextValue === consentGranted) {
      if (nextValue) emitInitialPageEvents();
      syncConsentReceipt(nextValue);
      return;
    }
    consentGranted = nextValue;
    command('consent', nextValue);
    if (nextValue) emitInitialPageEvents();
    syncConsentReceipt(nextValue);
  }

  function syncMarketingConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function') {
      setMarketingConsent(false);
      return;
    }
    try {
      setMarketingConsent(privacy.marketingAllowed() === true);
    } catch (error) {
      setMarketingConsent(false);
    }
  }

  document.addEventListener('visitorConsentCollected', function () { window.setTimeout(watchPixelReferences, 0); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') watchPixelReferences(); });
  window.addEventListener('pageshow', watchPixelReferences);
  window.addEventListener('load', watchPixelReferences);
  window.setTimeout(watchPixelReferences, 1000);

  document.addEventListener('visitorConsentCollected', function () {
    consentObservationMethod = 'visitor_interaction';
    syncMarketingConsent();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') syncMarketingConsent();
  });
  window.addEventListener('pageshow', syncMarketingConsent);

  function loadConsentApi() {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error) {
            setMarketingConsent(false);
            return;
          }
          syncMarketingConsent();
        }
      );
      return;
    }
    syncMarketingConsent();
  }

  function parseRequestedItems(input, init) {
    var body = init && init.body;
    var requested = Object.create(null);
    if (!body && input && typeof input === 'object') body = input.body;

    function add(id, quantity) {
      if (id === undefined || id === null || id === '') return;
      var key = String(id);
      requested[key] = (requested[key] || 0) + positiveInteger(quantity, 1);
    }

    if (body && typeof body.get === 'function') {
      add(body.get('id'), body.get('quantity'));
      return requested;
    }

    if (typeof body === 'string') {
      try {
        var parsed = JSON.parse(body);
        if (Array.isArray(parsed.items)) {
          parsed.items.forEach(function (item) { add(item.id, item.quantity); });
        } else {
          add(parsed.id, parsed.quantity);
        }
        return requested;
      } catch (error) {
        try {
          var params = new URLSearchParams(body);
          add(params.get('id'), params.get('quantity'));
        } catch (ignored) {}
      }
    }
    return requested;
  }

  function cartOperation(input, init) {
    var rawUrl = input && typeof input === 'object' && input.url ? input.url : input;
    var method = (init && init.method) || (input && input.method) || 'GET';
    if (typeof rawUrl !== 'string' || String(method).toUpperCase() !== 'POST') return '';
    try {
      var parsed = new URL(rawUrl, window.location.href);
      if (parsed.origin !== window.location.origin) return '';
      var match = parsed.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/);
      return match ? match[1] : '';
    } catch (error) {
      return '';
    }
  }

  function addedItemsFromResponse(data, requestedItems) {
    var rawItems = Array.isArray(data && data.items) ? data.items : [data];
    return rawItems.map(function (rawItem) {
      var rawId = rawItem && (rawItem.variant_id !== undefined ? rawItem.variant_id : rawItem.id);
      var requestedQuantity = requestedItems[String(rawId)];
      return normalizeItem(rawItem, requestedQuantity);
    }).filter(Boolean);
  }

  function mergeAddedItems(items) {
    items.forEach(function (addedItem) {
      var existing = null;
      for (var index = 0; index < cartState.items.length; index += 1) {
        if (cartState.items[index].id === addedItem.id) {
          existing = cartState.items[index];
          break;
        }
      }
      if (existing) {
        existing.quantity += addedItem.quantity;
        if (addedItem.amount !== null) existing.amount = addedItem.amount;
      } else {
        cartState.items.push(addedItem);
      }
    });
    cartState.total = null;
  }

  function refreshCartState(originalFetch) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    var cartUrl = (typeof root === 'string' ? root : '/') + 'cart.js';
    originalFetch.call(window, cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (data) {
        if (data) cartState = normalizeCart(data);
      })
      .catch(function () {});
  }

  function handleCartResponse(operation, data, requestedItems, originalFetch) {
    if (!data || (integer(data.status) !== null && integer(data.status) >= 400)) return;
    if (operation === 'add') {
      var addedItems = addedItemsFromResponse(data, requestedItems);
      if (!addedItems.length) return;
      mergeAddedItems(addedItems);
      var addedTotal = addedItems.reduce(function (sum, item) {
        return item.amount === null ? sum : sum + item.amount * item.quantity;
      }, 0);
      var hasEveryAmount = addedItems.every(function (item) { return item.amount !== null; });
      measure('items_added', contentsProperties(addedItems, hasEveryAmount ? addedTotal : null));
      refreshCartState(originalFetch);
      return;
    }
    cartState = normalizeCart(data);
  }

  if (typeof window.fetch === 'function' && !window.__bbOpenAIAdsFetchPatched) {
    window.__bbOpenAIAdsFetchPatched = true;
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var operation = cartOperation(input, init);
      var requestedItems = operation === 'add' ? parseRequestedItems(input, init) : Object.create(null);
      var responsePromise = originalFetch.apply(this, arguments);
      if (operation && responsePromise && typeof responsePromise.then === 'function') {
        responsePromise.then(function (response) {
          if (!response || !response.ok || typeof response.clone !== 'function') return;
          response.clone().json().then(function (data) {
            handleCartResponse(operation, data, requestedItems, originalFetch);
          }).catch(function () {});
        }).catch(function () {});
      }
      return responsePromise;
    };
  }

  function buyNowCart(trigger) {
    if (!trigger || typeof trigger.closest !== 'function') return null;
    var form = trigger.closest('form');
    if (!form || typeof form.querySelector !== 'function') return null;
    var idInput = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
    if (!idInput) return null;
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = positiveInteger(quantityInput && quantityInput.value, 1);
    var item = productItem(idInput.value, quantity);
    if (!item) return null;
    return { items: [item], total: item.amount === null ? null : item.amount * quantity };
  }

  function findCheckoutTrigger(target) {
    if (!target || typeof target.closest !== 'function') return null;
    var trigger = target.closest('[data-buynow-btn], [name="checkout"], a[href]');
    if (!trigger) return null;
    if (trigger.matches('[data-buynow-btn], [name="checkout"]')) return trigger;
    try {
      var href = new URL(trigger.href, window.location.href);
      return /\/checkout(?:\/|$)/.test(href.pathname) ? trigger : null;
    } catch (error) {
      return null;
    }
  }

  function emitCheckout(trigger) {
    if (!trigger || trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;
    var sourceCart = trigger.matches('[data-buynow-btn]') ? buyNowCart(trigger) : null;
    if (!sourceCart) sourceCart = cartState;
    measureOnce('checkout_started', 'checkout_started', contentsProperties(sourceCart.items, sourceCart.total));
  }

  document.addEventListener('click', function (event) {
    emitCheckout(findCheckoutTrigger(event.target));
  }, true);

  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (submitter && submitter.matches && submitter.matches('[name="checkout"]')) {
      emitCheckout(submitter);
      return;
    }
    var action = event.target && event.target.action;
    if (typeof action !== 'string') return;
    try {
      if (/\/checkout(?:\/|$)/.test(new URL(action, window.location.href).pathname)) {
        measureOnce('checkout_started', 'checkout_started', contentsProperties(cartState.items, cartState.total));
      }
    } catch (error) {}
  }, true);

  loadConsentApi();
})(window, document);
